import {
  CreateSubjectSmsHistoryDownloadUrlRequest,
  CreateSubjectSmsHistoryDownloadUrlResponse,
  SendEcoaAccessSmsRequest,
  SendEcoaAccessSmsResponse,
  SendEcoaAuthenticateSmsRequest,
  SendEcoaAuthenticateSmsResponse,
} from "./StudySms.dto";
import { StudySmsUrl } from "./StudySms.url";
import { restReq } from "../../common/cyan.types";
import { FxApiRequestData, FxRequestData } from "../../common/flax.types";
import { extractKey } from "../../common/HttpRequest";

export class StudySmsFlax {
  public static sendEcoaAccessSms(data: FxRequestData<SendEcoaAccessSmsRequest>): FxApiRequestData<SendEcoaAccessSmsResponse> {
    return {
      ...restReq(process.env.REACT_APP_CDMS_BE_URL, StudySmsUrl.sendEcoaAccessSms, data),
      reducer: resp => resp,
      errReducer: resp => resp,
    };
  }

  public static sendEcoaAuthenticateSms(
    data: FxRequestData<SendEcoaAuthenticateSmsRequest>
  ): FxApiRequestData<SendEcoaAuthenticateSmsResponse> {
    return {
      ...restReq(process.env.REACT_APP_CDMS_BE_URL, StudySmsUrl.sendEcoaAuthenticateSms, data),
      reducer: resp => resp,
      errReducer: resp => resp,
    };
  }

  public static createSubjectSmsHistoryDownloadUrl(
    data: FxRequestData<CreateSubjectSmsHistoryDownloadUrlRequest>
  ): FxApiRequestData<CreateSubjectSmsHistoryDownloadUrlResponse> {
    const studyId = extractKey(data, "studyId");

    return {
      ...restReq(process.env.REACT_APP_CDMS_BE_URL, StudySmsUrl.createSubjectSmsHistoryDownloadUrl(studyId), data),
      reducer: resp => resp,
      errReducer: resp => resp,
    };
  }
}
